<template>
  <div class="home" v-if="isAuthorized">
    <v-snackbar
        v-model="notificationsnackbar"
        :timeout="6000"
        :color="notificationcolor"
        :top="true"
        :right="true"
        :vertical="true"
    >
      {{ notificationtext }}
      <v-btn
          color="white"
          text
          @click="notificationsnackbar = false"
      >
        {{ $t("Notification.Schliessen") }}
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>


    <div class="bodyheader-home">
      <label class="label-bodyheader-home">
        <v-icon class="icon-home">mdi-home</v-icon>

        {{ $t("Home.Hotels") }}
      </label>

    </div>

    <div class="div-body-home">
      <div>
        <Search
            :halalHotels="halalHotels"
            from="home"
            :pLang="pLang"
        />

      </div>

      <div class="div-card-home">
        <template v-for="(info, index) in ownPlaces">
          <div v-if="info.min_price !== 0.00" :key="info.id !== undefined && info.id !== null ? info.id : index">
            <CY_CardPlace
                :hotelinfos="info"
                :checkin="checkin"
                :checkout="checkout"
                :groups="groups"
                :pLang="pLang"
                :pGruppen="gruppen.length"
                from="home"
            />
          </div>
        </template>

      </div>

      <h3>
        {{ $t("Home.Urlaubsziele") }}
      </h3>


      <div v-if="loading">
        <v-progress-circular
            indeterminate
            color="primary"
            :size="50"
            :width="7"

        />
        <SkeletonCardHorizontal/>
      </div>

      <div class="div-card-home">
        <div
            v-for="(info, index) in halalHotels.offers"
            :key="info.id !== undefined && info.id !== null ? info.id : index"
        >
          <CardPlace
              :hotelinfos="info"
              :checkin="checkin"
              :checkout="checkout"
              :groups="groups"
              :pLang="pLang"
              from="home"
          />
        </div>
      </div>

      <div v-if="moreloading">
        <v-progress-circular
            indeterminate
            color="primary"
            :size="50"
            :width="7"

        />

        <SkeletonCardHorizontal/>
      </div>


      <div class="div-paging-home">
        <v-btn @click="weitereErgebnisse" color="var(--Primary)" class="vbtn-more-home">
          <v-icon>mdi-chevron-down</v-icon>
          {{ $t("Button.WeitereErgebnisse") }}
        </v-btn>

      </div>
    </div>
  </div>
</template>

<script>
import {callapi, getInitPlaces} from "@/util/halalapi";
import CardPlace from "@/components/card/CardPlace";
import CY_CardPlace from "@/components/cy_card/CY_CardPlace";
import Search from "@/components/search/Search";
import SkeletonCardHorizontal from "@/components/skeletons/SkeletonCardHorizontal";
import {getOwnPlaces} from "@/util/OwnPlace";
import {checkChildrenAge, getLowestPrice} from "@/util/PriceOwnPlaceUtil";
import moment from "moment";
import {getCountry} from "@/util/Countries";
import {calculateCurrency} from "@/util/currencyUtil";

export default {
  name: "Home",
  props: [
    "pRolle",
    "pLang",
    "pCurrencyValues",
    "pCurrency"
  ],
  components: {
    CardPlace,
    CY_CardPlace,
    Search,
    SkeletonCardHorizontal
  },
  computed: {
    isAuthorized() {
      return ["reiseburo", "admin", "superadmin"].includes(this.pRolle);
    }
  },
  data() {
    return {
      notificationsnackbar: false,
      notificationtext: "",
      notificationcolor: "grey",
      loading: false,
      halalHotels: {offers: []},
      page: 1,
      moreloading: false,
      selectedholidayType: "xx",
      // holidayTypes: "thermal",
      checkin: "",
      checkout: "",
      groups: "&groups[]=2",
      url: "",
      gruppen: [],
      // Eigene Places
      ownPlaces: [],
      selectedstartdate: null,
      selectedenddate: null,
      anzahlNaechte: 0
    };
  },
  methods: {
    checkChildrenAge,
    getLowestPrice,
    notification(text, color) {
      this.notificationsnackbar = true;
      this.notificationtext = text;
      this.notificationcolor = color;
    },
    async weitereErgebnisse() {
      this.moreloading = true;
      this.page = this.page + 1;
      try {
        const data = this.url ? await callapi(this.url, this.page) : await getInitPlaces(this.page);
        if (data && Array.isArray(data.offers)) {
          if (!this.halalHotels.offers) {
            this.halalHotels.offers = [];
          }
          this.halalHotels.offers.push(...data.offers);
        }
      } finally {
        this.moreloading = false;
      }
    },
    getStoredHolidayType() {
      const stored = localStorage.getItem("ht");
      if (stored) {
        this.selectedholidayType = stored;
      }
    },
    getStoredDate(key, fallbackOffsetDays) {
      const stored = localStorage.getItem(key);
      if (stored !== null) {
        return new Date(stored);
      }
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() + fallbackOffsetDays);
    },
    setDatesFromStorage() {
      const cIn = this.getStoredDate("c-in", 16);
      const cOut = this.getStoredDate("c-out", 18);
      this.checkin = moment(cIn).format("YYYY-MM-DD");
      this.checkout = moment(cOut).format("YYYY-MM-DD");
      this.selectedstartdate = cIn;
      this.selectedenddate = cOut;
    },
    updateNights() {
      if (!this.selectedstartdate || !this.selectedenddate) {
        this.anzahlNaechte = 0;
        return;
      }
      const ms = this.selectedenddate.getTime() - this.selectedstartdate.getTime();
      this.anzahlNaechte = Math.floor(ms / (1000 * 60 * 60 * 24));
    },
    applyDestinationFilter(places) {
      const dest = localStorage.getItem("desP");
      if (!dest) {
        return places;
      }
      const needle = dest.toLocaleLowerCase();
      return places.filter((item) => {
        if (!item || !item.location) {
          return false;
        }
        const city = item.location.city ? item.location.city.toLowerCase() : "";
        const countryName = item.location.country ? getCountry("EN", item.location.country) : "";
        const country = countryName ? countryName.toLowerCase() : "";
        return city.includes(needle) || (country && needle === country);
      });
    },
    applyHolidayTypeFilter(places) {
      if (this.selectedholidayType === "xx") {
        return places;
      }
      return places.filter((item) => item.holiday_type && item.holiday_type.includes(this.selectedholidayType));
    },
    getStoredGroups() {
      const raw = localStorage.getItem("gruppe");
      if (!raw) {
        return null;
      }
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    },
    calculateMinPrice(place, groups) {
      let price = 0.00;
      if (groups && groups.length) {
        groups.forEach((group, index) => {
          const o = checkChildrenAge(groups, index, place.baby_price, place.children_price);
          price += getLowestPrice(o.erwachsene, o.children, o.babies, this.selectedstartdate, this.selectedenddate, place, this.anzahlNaechte);
        });
      } else {
        price = getLowestPrice(2, 0, 0, this.selectedstartdate, this.selectedenddate, place, this.anzahlNaechte);
      }
      return calculateCurrency(place.currency, this.pCurrency, this.pCurrencyValues, price);
    },
    updateOwnPlacesMinPrices(places, groups) {
      places.forEach((place) => {
        if (!place.rooms) {
          return;
        }
        try {
          place.min_price = this.calculateMinPrice(place, groups);
        } catch (e) {
          console.error("updateOwnPlacesMinPrices failed", e);
        }
      });
    },

    async loadOwnPlaces() {
      let places = [];
      try {
        places = await getOwnPlaces();
      } catch (e) {
        // console.error("getOwnPlaces failed", e);
        // this.notification("Eigene Hotels konnten nicht geladen werden.", "error");
      }
      if (!Array.isArray(places)) {
        places = [];
      }
      try {
        places = this.applyDestinationFilter(places);
      } catch (e) {
        // console.error("applyDestinationFilter failed", e);
      }
      const groups = this.getStoredGroups();
      try {
        this.updateOwnPlacesMinPrices(places, groups);
      } catch (e) {
        // console.error("updateOwnPlacesMinPrices failed", e);
      }
      try {
        places = this.applyHolidayTypeFilter(places);
      } catch (e) {
        // console.error("applyHolidayTypeFilter failed", e);
      }
      this.ownPlaces = places;
    },

    async loadHalalHotels(url, page = 1) {
      try {
        const data = url ? await callapi(url, page) : await getInitPlaces(page);
        if (!data || !Array.isArray(data.offers)) {
          return {offers: []};
        }
        return data;
      } catch (e) {
        return {offers: []};
      }
    },
    async handleUrlSearch(val) {
      this.getStoredHolidayType();
      this.loading = true;
      this.ownPlaces = [];
      this.halalHotels = {offers: []};
      try {
        this.halalHotels = await this.loadHalalHotels(val);
        this.url = val;
        this.page = 1;
        await this.loadOwnPlaces();
      } catch (e) {
        // console.error("handleUrlSearch failed", e);
        // this.notification("Suche fehlgeschlagen.", "error");
      } finally {
        this.loading = false;
      }
    },
    onLoading(val) {
      this.loading = val;
    },
    onCheckin() {
      const cIn = this.getStoredDate("c-in", 16);
      this.checkin = moment(cIn).format("YYYY-MM-DD");
      this.selectedstartdate = cIn;
      this.updateNights();
    },
    onCheckout() {
      const cOut = this.getStoredDate("c-out", 18);
      this.checkout = moment(cOut).format("YYYY-MM-DD");
      this.selectedenddate = cOut;
      this.updateNights();
    },
    onGroups(val) {
      this.groups = val;
    },
    onCysearch(val) {
      this.gruppen = Array.isArray(val) ? val : [];
      this.updateOwnPlacesMinPrices(this.ownPlaces, this.gruppen);
    }
  },
  mounted() {
    this.$root.$on("urlxx", this.handleUrlSearch);
    this.$root.$on("loading", this.onLoading);
    this.$root.$on("checkin", this.onCheckin);
    this.$root.$on("checkout", this.onCheckout);
    this.$root.$on("groups", this.onGroups);
    this.$root.$on("cysearch", this.onCysearch);
  },
  beforeDestroy() {
    this.$root.$off("urlxx", this.handleUrlSearch);
    this.$root.$off("loading", this.onLoading);
    this.$root.$off("checkin", this.onCheckin);
    this.$root.$off("checkout", this.onCheckout);
    this.$root.$off("groups", this.onGroups);
    this.$root.$off("cysearch", this.onCysearch);
  },
  async created() {
    this.loading = true;

    if (localStorage.getItem("nlo")) {
      localStorage.removeItem("nlo");
      location.reload();
    }

    this.getStoredHolidayType();

    // localStorage.removeItem("gruppe");
    window.scrollTo(0, 0);

    if (localStorage.getItem("url")) {
      this.halalHotels = await this.loadHalalHotels(localStorage.getItem("url"));
    } else {
      this.halalHotels = await this.loadHalalHotels("", 1);
    }
    this.loading = false;

    this.setDatesFromStorage();
    this.updateNights();
    await this.loadOwnPlaces();
  }
};
</script>
<style scoped>
@import "../css/Home.css";
</style>
